<div class="d-flex leftselectbx">
    <div>
        <div class="d-flex">
            <div class="labelbx">
                <label>Select Group</label>
                <mat-form-field appearance="fill">
                    <mat-select (selectionChange)="groupDropDown($event.value.groupId); tableLoad()"
                        [(ngModel)]="allFileFilter.group" name="group" required>
                        <mat-option [value]="0">All</mat-option>
                        <mat-option *ngFor="let list of addGroupList" [value]="list">{{list.groupName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="labelbx">
                <label>Select Category</label>
                <mat-form-field appearance="fill">
                    <mat-select (selectionChange)="CategoryDropDown($event.value.categoryId); tableLoad()"
                        [(ngModel)]="allFileFilter.category" name="category" required>
                        <mat-option [value]="0">All</mat-option>
                        <mat-option *ngFor="let catList of CategoryDropList" [value]="catList">
                            {{catList.categoryName}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="labelbx">
                <label>Select Sub Category</label>
                <mat-form-field appearance="fill">
                    <mat-select [(ngModel)]="allFileFilter.subCategory" name="subCategory"
                        (selectionChange)="tableLoad()" required>
                        <mat-option [value]="0">All</mat-option>
                        <mat-option *ngFor="let sublist of subCategoryList" [value]="sublist">
                            {{sublist.subCategoryName}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="clearfi-txt" *ngIf="allFileFilter?.group || allFileFilter?.category || allFileFilter?.subCategory">
        <a (click)="clearFilter()">Clear Filter</a>
    </div>
</div>